module.exports = __webpack_public_path__ + "static/media/love_icon.e69586f4.svg";